import type { ReactElement } from "react";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { Datagrid, ImageField, TextField, useListContext } from "react-admin";
import { useNavigate } from "react-router";
import { Column } from "../../misc/Column";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { DrivingSchoolCustomCard } from "../../providers/drivingSchoolCustomCardsProvider";
import { CustomCardMobileListItem } from "./CustomCardMobileListItem";

export function CustomCardsDataGrid(props: { empty?: ReactElement }) {
  const { empty } = props;
  const { isLoading, data, total } = useListContext<DrivingSchoolCustomCard>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((customCard) => (
          <CustomCardMobileListItem
            key={customCard.id}
            customCard={customCard}
            onClick={() => navigate(`/customCards/${customCard.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick="edit" bulkActionButtons={false} empty={empty}>
      <ImageField label="Bild" source="imageUrl" />
      <TextField label="Titel" source="title" />
      <TextField label="Text" source="description" />
      <TextField label="Button Beschriftung" source="ctaLabel" />
      <TextField label="Button Link" source="ctaLink" />
    </Datagrid>
  );
}
